export default "__VITE_ASSET__DOyQWWXR__"